import {
  Box,
  Button,
  CircularProgress,
  Stack,
  Typography,
} from "@mui/material";
import SettingIcon from "src/assets/svg-icons/side-bar/settings.svg";
import RightArrow from "src/assets/svg-icons/aggregators/right_arrow.svg";
import InfoItem from "./info-item";
import { useNavigate, useParams } from "react-router-dom";
import { formatNumber } from "src/utils";
import { useTranslation } from "react-i18next";
import TransactionItemsTable from "./items-table";
import { useGetPoRequestById } from "src/api/inventory/reorder";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { useRef } from "react";

const PoRequestDetails = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { t } = useTranslation("inventory");
  const { t: purchasingT } = useTranslation("purchasing");
  const { t: generalT } = useTranslation("general");
  const pdfRef = useRef(null);

  const { data, isLoading } = useGetPoRequestById(id || "");

  const downloadPDF = async () => {
    const element = pdfRef.current;

    const canvas = await html2canvas(element as any, {
      scale: 2,
      useCORS: true,
    });

    const imgData = canvas.toDataURL("image/png");

    const pdf = new jsPDF("p", "mm", "a4");

    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

    pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);

    pdf.save("PO-request-detail.pdf");
  };

  const navigateToReorder = () => {
    navigate("/inventory/reorder");
  };

  return (
    <Stack gap={3} p={{ xs: 2, sm: 4 }} ref={pdfRef}>
      <Stack
        direction={"row"}
        spacing={"12px"}
        alignItems={"center"}
        color={"#101828"}
      >
        <Box
          display={"flex"}
          justifyContent={"center"}
          alignItems={"center"}
          width={"60px"}
          height={"60px"}
          bgcolor={"#D0D5DD"}
          borderRadius={"16px"}
        >
          <img src={SettingIcon} width={"32px"} alt="" />
        </Box>
        <Typography fontSize={"32px"} lineHeight={"38.4px"}>
          {purchasingT("transactionDetails")}
        </Typography>
      </Stack>

      {/* divider */}
      <Box bgcolor={"#F2F4F7"} width={"100%"} height={"1px"} />

      <Stack
        justifyContent={"space-between"}
        spacing={2}
        direction={"row"}
        alignItems={"center"}
      >
        <Stack spacing={2} direction={"row"} alignItems={"center"}>
          <Typography
            color={"#475467"}
            lineHeight={"19.2px"}
            onClick={navigateToReorder}
            sx={{ cursor: "pointer" }}
          >
            {t("inventory")}
          </Typography>
          <img src={RightArrow} alt="" />
          <Typography
            color={"#475467"}
            lineHeight={"19.2px"}
            sx={{ cursor: "pointer" }}
            onClick={navigateToReorder}
          >
            {t("reorder")}
          </Typography>
          <img src={RightArrow} alt="" />
          <Box borderRadius={"4px"} bgcolor={"#EAECF0"} p={"4px 8px"}>
            <Typography
              color={"#344054"}
              fontWeight={600}
              lineHeight={"19.2px"}
            >
              {data?.data.reference}
            </Typography>
          </Box>
        </Stack>
        <Button
          variant="outlined"
          onClick={downloadPDF}
          data-html2canvas-ignore
        >
          {generalT("download")}
        </Button>
      </Stack>

      {isLoading && !data ? (
        <Box display={"flex"} justifyContent={"center"} pt={20}>
          <CircularProgress />
        </Box>
      ) : (
        <>
          <Stack bgcolor={"#F9FAFB"} spacing={1.5} p={2}>
            <Typography
              fontSize={"14px"}
              color={"#344054"}
              fontWeight={700}
              lineHeight={"18.8px"}
            >
              {generalT("branch")}:
              <Typography
                component={"span"}
                fontWeight={400}
                fontSize={"14px"}
                lineHeight={"18.8px"}
              >
                {" "}
                {data?.data.branch.name}
              </Typography>
            </Typography>

            <InfoItem
              title={purchasingT("supplier")}
              text={`${data?.data.supplier?.name || ""}`}
              label={t("approvedBy")}
              value={`${data?.data.sent_by ?? ""}`}
            />

            <InfoItem
              title={t("items")}
              text={`${data?.data.items_count}`}
              label={t("approvedAt")}
              value={data?.data.sent_at}
            />
            <InfoItem
              title={t("expectedTotal")}
              text={`${formatNumber(data?.data.items_total)}`}
              label={t("sentBy")}
              value={data?.data.created_by?.name}
            />
            <InfoItem
              title={t("sentStatus")}
              text={`${
                data?.data.sent_email
                  ? t("sentEmail")
                  : data?.data.sent_app
                    ? t("sentApp")
                    : t("notSent")
              }`}
              label={t("sentAt")}
              value={`${data?.data.created_at}`}
            />
            <InfoItem
              title={generalT("status")}
              text={`${data?.data.status || ""}`}
              label={""}
              value={``}
            />
          </Stack>
          <TransactionItemsTable list={data.data.items} isLoading={isLoading} />
        </>
      )}
    </Stack>
  );
};

export default PoRequestDetails;
